import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-setting_tips",
  "use": "icon-setting_tips-usage",
  "viewBox": "0 0 28 28",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 28 28\" id=\"icon-setting_tips\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M-2-2h32v32H-2z\" /><path d=\"M14 27.333C6.636 27.333.667 21.364.667 14S6.636.667 14 .667 27.333 6.636 27.333 14 21.364 27.333 14 27.333Zm-1.333-14.666v8h2.666v-8h-2.666Zm0-5.334V10h2.666V7.333h-2.666Z\" fill=\"#0FBA57\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol